// // What stages you are in (2 section)

// import React, { useState, useRef } from 'react';
// import data from '../../femcare-content.json';
// import { useNavigate } from 'react-router-dom';
// import TalkToCareGuideButton from '../whatsapp/whatsappIntegration';

// const { stages } = data.sections;

// const WhatStages = () => {
//   const { id, heading, items } = stages;
// const navigate=useNavigate()

//   const [startIndex, setStartIndex] = useState(0);
//   const touchStartX = useRef(0);
//   const touchEndX = useRef(0);

//   const getVisibleCount = () => {
//     if (typeof window === 'undefined') return 4;
//     if (window.innerWidth < 640) return 1;     // mobile
//     if (window.innerWidth < 1024) return 2;    // tablet
//     return 4;                                  // desktop
//   };

//   const [visibleCount, setVisibleCount] = useState(getVisibleCount());

//   React.useEffect(() => {
//     const handleResize = () => {
//       setVisibleCount(getVisibleCount());
//       setStartIndex(0);
//     };
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const maxStart = Math.max(0, items.length - visibleCount);
//   const canPrev = startIndex > 0;
//   const canNext = startIndex < maxStart;

//   const handlePrev = () => {
//     if (canPrev) setStartIndex((prev) => prev - 1);
//   };

//   const handleNext = () => {
//     if (canNext) setStartIndex((prev) => prev + 1);
//   };

//   /* Swipe Handlers */
//   const onTouchStart = (e) => {
//     touchStartX.current = e.targetTouches[0].clientX;
//   };

//   const onTouchMove = (e) => {
//     touchEndX.current = e.targetTouches[0].clientX;
//   };

//   const onTouchEnd = () => {
//     const distance = touchStartX.current - touchEndX.current;

//     if (distance > 50 && canNext) {
//       handleNext(); // swipe left
//     } else if (distance < -50 && canPrev) {
//       handlePrev(); // swipe right
//     }
//   };

//   // return (
//   //   <section id={id} className="w-full py-6 md:py-8" 
//   //   style={{ backgroundColor: 'var(--gray-100)' }}
//   //   >
//   //     <div className="container mx-auto px-4 md:px-8">

//   //       <div
//   //         className="w-full rounded-2xl bg-white px-6 md:px-8 py-6 md:py-8"
//   //         style={{ boxShadow: '0 2px 16px rgba(0,0,0,0.06)' }}
//   //       >

//   //         {/* Header */}
//   //         <div className="flex items-end justify-between mb-6">
//   //           <div>
//   //             <h2
//   //               className="ava-heading-lg "
//   //               // style={{ color: 'var(--primary-color)' }}
//   //             >
//   //               {heading}
//   //             </h2>
//   //             {/* <div
//   //               className="mt-1.5 rounded-full"
//   //               style={{
//   //                 height: '3px',
//   //                 width: '100%',
//   //                 backgroundColor: 'var(--primary-color)',
//   //               }}
//   //             /> */}
//   //           </div>

//   //           {/* Arrows */}
//   //           {items.length > visibleCount && (
//   //             <div className="flex items-center gap-2 ml-4">
//   //               <ArrowBtn direction="left" onClick={handlePrev} disabled={!canPrev} />
//   //               <ArrowBtn direction="right" onClick={handleNext} disabled={!canNext} />
//   //             </div>
//   //           )}
//   //         </div>

//   //         {/* Swipe + Sliding Container */}
//   //         <div
//   //           className="overflow-hidden"
//   //           onTouchStart={onTouchStart}
//   //           onTouchMove={onTouchMove}
//   //           onTouchEnd={onTouchEnd}
//   //         >
//   //           <div
//   //             className="flex transition-transform duration-300"
//   //             style={{
//   //               transform: `translateX(-${(100 / visibleCount) * startIndex}%)`,
//   //             }}
//   //           >
//   //             {items.map((item) => (
//   //               <div
//   //                 key={item.id}
//   //                 style={{
//   //                   flex: `0 0 ${100 / visibleCount}%`,
//   //                   padding: '0 6px',
//   //                 }}
//   //               >
//   //                 <SymptomCard item={item} />
//   //               </div>
//   //             ))}
//   //           </div>
//   //         </div>

//   //       </div>
//   //     </div>
//   //   </section>
//   // );

//   return (
//     <section id={id} className="w-full py-6 md:py-8"
//       style={{ backgroundColor: 'var(--gray-100)' }}
//     >
//       <div className="container mx-auto px-4 md:px-8">
//         <div
//           className="w-full ava-radius-md bg-white px-6 md:px-8 py-6 md:py-8"
//           style={{ boxShadow: '0 2px 16px rgba(0,0,0,0.06)' }}
//         >

//           {/* Header — no arrows here anymore */}
//           <div className="flex items-end justify-between mb-6">
//             <h2 className="ava-heading-lg">{heading}</h2>
//           </div>

//           {/* Slider wrapper — position relative so arrows can overlay */}
//           <div className="relative">

//             {/* Left Arrow — on the image, left edge */}
//             {/* {canPrev && ( */}
//             <div
//               className="absolute z-10"
//               style={{
//                 left: '-15px',
//                 top: '50%',
//                 transform: 'translateY(-50%)',
//                 aspectRatio: '4/3', // keeps it centered in the image height zone
//                 display: 'flex',
//                 alignItems: 'center',
//               }}
//             >
//               {/* <ArrowBtn direction="left" onClick={handlePrev}
//                 disabled={!canPrev}
//               /> */}
//             </div>
//             {/* )} */}

//             {/* Right Arrow — on the image, right edge */}
//             {/* {canNext && ( */}
//             <div
//               className="absolute z-10"
//               style={{
//                 right: '-15px',
//                 top: '50%',
//                 transform: 'translateY(-50%)',
//                 display: 'flex',
//                 alignItems: 'center',
//               }}
//             >
//               {/* <ArrowBtn direction="right" onClick={handleNext} disabled={!canNext} /> */}
//             </div>
//             {/* )} */}

//             {/* Sliding track */}
//             <div
//               className="overflow-hidden"
//               onTouchStart={onTouchStart}
//               onTouchMove={onTouchMove}
//               onTouchEnd={onTouchEnd}
//             >
//               <div
//                 className="flex ava-card-gap transition-transform duration-300"
//                 style={{
//                   transform: `translateX(-${(100 / visibleCount) * startIndex}%)`,
//                 }}
//               >
//                 {items.map((item) => (
//                   <div
//                     key={item.id}
//                     //   style={{

//                     //     flex: `0 0 calc(
//                     //   (100% - ((${visibleCount} - 1) * var(--ava-card-gap)))
//                     //   / ${visibleCount}
//                     // )`,

//                     //   }}
//                     style={{
//                       flex: "0 0 18%",
//                     }}
//                   >
//                     <SymptomCard item={item} />
//                   </div>
//                 ))}
//               </div>
//             </div>

//           </div>

//            <p className='ava-text-subheading text-center mt-5'>Get personalized guidance for your health concerns.</p>
//            <div className='flex items-center justify-center mt-5 gap-3'>
//             {/* <button className='btn-transparent' onClick={()=>navigate('/health-assessment')}>
//               Talk to Care Guide
//             </button> */}
//             <TalkToCareGuideButton className='btn-transparent'/>
//             <button className='btn-primary' onClick={()=>navigate('/health-assessment')}>
//               Take Assessment
//             </button>
//            </div>
//         </div>
//       </div>
     
//     </section>
//   );
//   // };
// };

// /* Arrow */
// const ArrowBtn = ({ direction, onClick, disabled }) => (
//   <button
//     onClick={onClick}
//     disabled={disabled}
//     className={`w-10 h-10 flex items-center justify-center rounded-full bg-white border ${disabled ? 'ava-arrow-disabled' : 'ava-arrow-active'}`}

//     style={{ cursor: disabled ? 'not-allowed' : 'pointer', borderColor: disabled ? 'var(--gray-300)' : 'var(--primary-color)', opacity: disabled ? 0.4 : 1 }}
//   >
//     <img
//       src={direction === 'left' ? '/images/left-arrow.svg' : '/images/right-arrow.svg'}
//       alt={direction}
//       className="w-10 h-10"
//     />
//   </button>
// );

// /* Card */
// const SymptomCard = ({ item }) => {
//   return (
//     <div
//       // href={item.href || '#'}
//       className="relative block ava-radius-md overflow-hidden group "
//       style={{ aspectRatio: '4/3' }}
//     >
//       <img
//         src={item.image}
//         alt={item.label}
//         className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
//       />

//       <div
//         className="absolute inset-0"
//         style={{
//           background: 'linear-gradient(to bottom, rgba(0,0,0,0.08) 0%, rgba(0,0,0,0.28) 100%)',
//         }}
//       />

//       {/* Reduced font for mobile & tablet */}
//       <div
//         className="absolute top-3 left-3 ava-radius-md px-2 py-1 text-white ava-text-body"
//         style={{
//           backgroundColor: 'var(--secondary-color)',
//           // fontSize: 'clamp(0.65rem, 1.2vw, 0.85rem)',
//         }}
//       >
//         {item.label}
//       </div>
//     </div>
//   );
// };

// export default WhatStages;


// What stages you are in (2 section)

import React, { useState, useRef } from 'react';
import data from '../../femcare-content.json';
import { useNavigate } from 'react-router-dom';
import TalkToCareGuideButton from '../whatsapp/whatsappIntegration';

const { stages } = data.sections;

const WhatStages = () => {
  const { id, heading, items } = stages;
  const navigate = useNavigate();

  const [startIndex, setStartIndex] = useState(0);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const getVisibleCount = () => {
    if (typeof window === 'undefined') return 4;
    if (window.innerWidth < 640) return 1;     // mobile
    if (window.innerWidth < 1024) return 2;    // tablet
    return 4;                                  // desktop
  };

  const [visibleCount, setVisibleCount] = useState(getVisibleCount());

  React.useEffect(() => {
    const handleResize = () => {
      setVisibleCount(getVisibleCount());
      setStartIndex(0);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const maxStart = Math.max(0, items.length - visibleCount);
  const canPrev = startIndex > 0;
  const canNext = startIndex < maxStart;
  const showNavArrows = items.length > visibleCount;

  const handlePrev = () => { if (canPrev) setStartIndex((prev) => prev - 1); };
  const handleNext = () => { if (canNext) setStartIndex((prev) => prev + 1); };

  const onTouchStart = (e) => { touchStartX.current = e.targetTouches[0].clientX; };
  const onTouchMove = (e) => { touchEndX.current = e.targetTouches[0].clientX; };
  const onTouchEnd = () => {
    const distance = touchStartX.current - touchEndX.current;
    if (distance > 50 && canNext) handleNext();
    else if (distance < -50 && canPrev) handlePrev();
  };

  return (
    <section id={id} className="w-full py-6 md:py-8" style={{ backgroundColor: 'var(--gray-100)' }}>
      <div className="container mx-auto px-4 md:px-8">
        <div
          className="w-full ava-radius-md bg-white px-6 md:px-8 py-6 md:py-8"
          style={{ boxShadow: '0 2px 16px rgba(0,0,0,0.06)' }}
        >
          <div className="flex items-end justify-between mb-6">
            <h2 className="ava-heading-lg">{heading}</h2>
          </div>

          {/* Carousel wrapper with edge-positioned arrows */}
          <div className="relative">

            {showNavArrows && (
              <ArrowBtn direction="left" onClick={handlePrev} disabled={!canPrev} position="left" />
            )}

            <div
              className="overflow-hidden"
              onTouchStart={onTouchStart}
              onTouchMove={onTouchMove}
              onTouchEnd={onTouchEnd}
            >
              <div
                className="flex transition-transform duration-300"
                style={{
                  transform: `translateX(-${(100 / visibleCount) * startIndex}%)`,
                }}
              >
                {items.map((item) => (
                  <div
                    key={item.id}
                    style={{
                      flex: `0 0 calc(${100 / visibleCount}%)`,
                      padding: '0 0.5vw',
                    }}
                  >
                    <SymptomCard item={item} />
                  </div>
                ))}
              </div>
            </div>

            {showNavArrows && (
              <ArrowBtn direction="right" onClick={handleNext} disabled={!canNext} position="right" />
            )}
          </div>

          <p className="ava-text-subheading text-center mt-5">Get personalized guidance for your health concerns.</p>
          <div className="flex items-center justify-center mt-5 gap-3">
            <TalkToCareGuideButton className="btn-transparent" />
            <button className="btn-primary" onClick={() => navigate('/health-assessment')}>
              Take Assessment
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

/* Arrow */
const ArrowBtn = ({ direction, onClick, disabled, position }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    aria-label={direction === 'left' ? 'Previous' : 'Next'}
    style={{
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 10,
      ...(position === 'left' ? { left: '-22px' } : { right: '-22px' }),
      width: '44px',
      height: '44px',
      borderRadius: '50%',
      backgroundColor: '#ffffff',
      border: `1.5px solid ${disabled ? '#d1d5db' : 'var(--primary-color)'}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.4 : 1,
      boxShadow: disabled ? 'none' : '0 1px 6px rgba(0,0,0,0.12)',
      transition: 'all 0.2s ease',
      padding: 0,
    }}
  >
    {direction === 'left' ? (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={disabled ? '#9ca3af' : 'var(--primary-color)'} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="15 18 9 12 15 6" />
      </svg>
    ) : (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={disabled ? '#9ca3af' : 'var(--primary-color)'} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="9 18 15 12 9 6" />
      </svg>
    )}
  </button>
);

/* Card */
const SymptomCard = ({ item }) => {
  return (
    <div
      className="relative block ava-radius-md overflow-hidden group"
      // style={{ aspectRatio: '4/3' }}
      style={{ aspectRatio: '16/10' }}
      // style={{ aspectRatio: '1/1' }}

    >
      <img
        src={item.image}
        alt={item.label}
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
      />
      <div
        className="absolute inset-0"
        style={{ background: 'linear-gradient(to bottom, rgba(0,0,0,0.08) 0%, rgba(0,0,0,0.28) 100%)' }}
      />
      <div
        className="absolute top-3 left-3 ava-radius-md px-2 py-1 text-white ava-text-body"
        style={{ backgroundColor: 'var(--secondary-color)' }}
      >
        {item.label}
      </div>
    </div>
  );
};

export default WhatStages;